import { agentHubRollout, canReadAnyAgentSelector } from '@lumapps/agent-hub/ducks/selectors';
import { createSelector } from '@lumapps/redux/reselect';
import { serviceSettingsSelector } from '@lumapps/service-settings/ducks/selectors';

import { GlobalAgentChatState } from '../types';

const globalAgentChatSelector = (state: FrontOfficeStore | BackOfficeStore): GlobalAgentChatState | undefined =>
    state.agentChat;

/**
 * Retrieves whether the global agent chat is accessible to the current user: the Agent Hub FF
 * must be on AND the user must have access to at least one agent.
 */
export const canAccessAgentChatSelector = createSelector(
    agentHubRollout.isGA,
    canReadAnyAgentSelector,
    (isEnabled, hasAgentReadPermission) => isEnabled && hasAgentReadPermission,
);

/**
 * Whether to show the floating agent-chat button: accessible AND the org `askAgentFloatingButton`
 * setting isn't off (absent → shown, default-on). Surfaces without `serviceSettings` (back-office,
 * webview, designer) stay access-gated and auto-honor the setting if the backend later sends it.
 */
export const canDisplayAgentChatButtonSelector = createSelector(
    canAccessAgentChatSelector,
    serviceSettingsSelector,
    (canAccessAgentChat, serviceSettings) =>
        canAccessAgentChat && (serviceSettings?.askAgentFloatingButton?.isEnabled ?? true),
);

export const isChatOpenedSelector = createSelector(globalAgentChatSelector, (agentChat) => agentChat?.isChatOpen);

export const selectedChatAgentSelector = createSelector(
    globalAgentChatSelector,
    (agentChat) => agentChat?.selectedAgent,
);
export const pendingAgentChangeSelector = createSelector(
    globalAgentChatSelector,
    (agentChat) => agentChat?.pendingAgentChange,
);

export const agentContextSelector = createSelector(globalAgentChatSelector, (agentChat) => agentChat?.agentContext);
